<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'

withDefaults(
  defineProps<{
    title?: string
  }>(),
  {
    title: 'Siap Bikin Checkout Toko WooCommerce Lebih Cepat & Praktis?'
  }
)
</script>

<template>
  <section>
    <UiContainer>
      <div
        class="flex flex-col lg:flex-row gap-6 items-center lg:items-end pt-4 px-8 lg:px-12 lg:pt-8 bg-surface-container rounded-3xl"
      >
        <div class="flex-1">
          <div class="justify-center flex flex-col pb-8">
            <UiSectionTitle
              class="mb-5 lg:mb-8"
              variant-size="small"
              title-as="h2"
              :title="title"
            />
            <div class="flex items-center gap-2 lg:gap-4 py-2">
              <UiButton
                :to="
                  $utm.utmUrl(
                    WEB_APP_URL +
                      '/register?redirectTo=/settings/api-request?plugin=woocommerce'
                  )
                "
                label="Install Plugin"
                target="_blank"
                icon="material-symbols:download"
              />
              <UiButton
                :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
                label="Hubungi Kami"
                variant="primaryOutline"
                icon="material-symbols:call-outline"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 max-w-[440px]">
          <NuxtImg
            src="/images/plugin/woocommerce/mini-cta.webp"
            alt="ROMS: Bluetick"
            class="w-full"
          />
        </div>
      </div>
    </UiContainer>
  </section>
</template>
